import React, { useState, createContext } from 'react';
import PropTypes from 'prop-types';

// Store:
// currentTopic
// If initialoverview screen
// number of circles
// if menu is open

export const TopicContext = createContext({
  currentTopic: undefined,
  initialOverview: true,
  numberOfCircles: 9,
  isNavigationOpen: false,
});

const TopicProvider = ({ children }) => {
  const [currentTopic, setCurrentTopic] = useState(undefined);
  const [initialOverview, setinitialOverview] = useState(true);
  const [isNavigationOpen, setIsNavigationOpen] = useState(false);

  const valueProps = {
    currentTopic,
    setCurrentTopic,
    initialOverview,
    setinitialOverview,
    numberOfCircles: 9,
    isNavigationOpen,
    setIsNavigationOpen,
  };

  // console.log('currentTopic:', currentTopic);
  return (
    <TopicContext.Provider value={valueProps}>{children}</TopicContext.Provider>
  );
};

TopicProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TopicProvider;
